import { BaseService } from '../base.service';
import { ResponseWrapper, ApiError } from '../http';

export class OwnersService extends BaseService {
  static get resourceEndpoint() {
    return 'owners/owners';
  }
  static async update(data = {}) {
    try {
      const response = await this.request().patch(
        `${this.resourceEndpoint}`,
        data
      );
      return new ResponseWrapper(response);
    } catch (error) {
      throw new ApiError(error);
    }
  }

  static async unsubscribeCancel(data = {}) {
    try {
      const response = await this.request().post(
        'owners/unsubscribe_cancel',
        data
      );
      return new ResponseWrapper(response);
    } catch (error) {
      throw new ApiError(error);
    }
  }
}